/* BackupEditor.js */

"use strict";

/**
 * @type {uiCoreTools}
 */
const uiCore = require("@gluenetworks/steve_ui_core");
const CommonEditor = require("./CommonEditor");

const SingleComboBoxControl = uiCore.Control.OptionSelection.Single.ComboBox;

class BackupEditor extends CommonEditor {
    constructor(args) {
        super(args);
        this._item = args.item;
        this.backupsMap = {};
        const options = this._item.backupsList.map((backup) => {
            // some test or bad data may not have a description, so fallback to time with new approve time format
            const description =
                backup.description ||
                `Backup -  ${new Date(backup.capturedTime).toLocaleDateString()} ${new Date(
                    backup.capturedTime
                ).toLocaleTimeString({}, {timeZoneName: "short"})}`;
            this.backupsMap[backup.id] = description;
            return {
                label: description,
                value: backup.id,
            };
        });

        this.input.setOptions(options);
        this.input.setValue(this._item.backupId);
        this.rootElement.classList.add("select");
    }

    _init() {
        // const options = typeLabelsList.map((label) => ({
        //     label: label,
        //     value: typeDataByLabel(label).dataType
        // }));
        // this.input.setOptions(options);

        super._init();
    }

    applyValue(item, state) {
        super.applyValue(item, state);
        item.backupId = state;
        item.backup = this.backupsMap[state];
    }

    /**
     *
     * @returns {ComboBoxControlComponent}
     * @private
     */
    _createInput() {
        return new SingleComboBoxControl({
            showFilter: false,
            darkTheme: true,
            adjustWidth: true,
            allowClear: false,
        });
    }
}

module.exports = BackupEditor;
